<script setup>
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/modules/notifications/stores/notifications.store'

const router = useRouter()
const store = useNotificationsStore()

function navigateToNotifications() {
  router.push({ name: 'Notifications' })
}
</script>

<template>
  <div
    class="relative flex cursor-pointer"
    @click="navigateToNotifications"
  >
    <i class="pi pi-bell" />
    <span
      v-if="store.unreadCount > 0"
      class="absolute -top-1 -right-1 flex items-center justify-center min-w-4 h-4 px-0.5 rounded-full text-white bg-red-500 dark:bg-red-400 text-xs font-bold leading-none"
    >
      {{ store.unreadCount > 99 ? '99+' : store.unreadCount }}
    </span>
  </div>
</template>
